import { format, max, min, parseISO, subDays, subMonths } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import React, { useState } from 'react'
import { useQuery } from 'react-query'

import { PortadorasService } from '../../../../services/http/portadoras.service'
import Botao from '../../../Mantine/Botao'
import DatePicker from '../../../Mantine/DatePicker'
import Group from '../../../Mantine/Group'
import LineSkeleton from '../../../Mantine/Skeleton/line'

import Grafico from './Grafico'
import * as S from './styles'

const buttons = [
  { value: '24h', label: 'Últimas 24h' },
  { value: '48h', label: 'Últimas 48h' },
  { value: '7d', label: 'Últimos 7 dias' },
  { value: '15d', label: 'Últimos 15 dias' },
  { value: '30d', label: 'Últimos 30 dias' },
  { value: 'periodo', label: 'Por período' }
]

const formatDate = (date) => format(date, 'dd/MM/yyyy - EEEE', { locale: ptBR })

const DEFAULT_DATA = { start: null, end: null }

export default function Historico({ cdPortadora }) {
  // const [mostrarAlerta, setMostrarAlerta] = useState(false)
  const [selectedButton, setSelectedButton] = useState('24h')
  const [selectedDate, setSelectedDate] = useState(DEFAULT_DATA)
  const [visibleDate, setVisibleDate] = useState(false)
  const [loading, setLoading] = useState()
  const [datasDisponiveis, setDatasDisponiveis] = useState({
    min: undefined,
    max: undefined
  })

  const isPeriodo = selectedButton === 'periodo'

  const today = new Date()

  const minDatePeriodo = subMonths(today, 3)

  const { getHistorico } = PortadorasService

  const handleButtonFilter = (value) => {
    if (value !== 'periodo') {
      setVisibleDate(false)
      setSelectedDate(DEFAULT_DATA)
    } else setVisibleDate(true)

    // setMostrarAlerta(false)
    setSelectedButton(value)
  }

  const handleSelectedDate = (field, value) => {
    setSelectedDate((prev) => ({
      ...prev,
      [field]: value
    }))
  }

  const { data } = useQuery(
    [`history-${cdPortadora}`, selectedButton, selectedDate],
    async () => {
      try {
        setLoading(true)
        return await getHistorico(cdPortadora, selectedButton, selectedDate)
      } catch (err) {
        console.error('Erro ao buscar histórico:', err)
        return [] // Evita erros ao mapear `data` caso falhe
      } finally {
        setLoading(false)
      }
    },
    {
      onSuccess: (data) => {
        if (!data?.length) return

        const parsedDates = data.map((item) => parseISO(item.data))
        const minDate = min(parsedDates)
        const maxDate = max(parsedDates)
        setDatasDisponiveis({
          min: minDate,
          max: maxDate
        })

        //! Rogerio falou pra deixar comentado para ver se ocorre algum caso que precise da mensagem
        // if (isPeriodo) {
        //   const isMaxDateBeforeSelectedEnd = selectedDate.end
        //     ? isBefore(maxDate, selectedDate.end)
        //     : false

        //   const isMinDateAfterSelectedStart = selectedDate.start
        //     ? isAfter(minDate, selectedDate.start)
        //     : false

        //   if (isMinDateAfterSelectedStart || isMaxDateBeforeSelectedEnd) {
        //     setMostrarAlerta(true)
        //   } else {
        //     setMostrarAlerta(false)
        //   }

        //   return
        // }

        // // Verifica se a data máxima é menor que hoje
        // const isMaxDateBeforeToday = isBefore(maxDate, today)

        // // Calcula a data inicial com base no periodo
        // const days = parseInt(selectedButton, 10)
        // const startDate = subDays(today, days)

        // // Verifica se a menor data é maior que a data inicial
        // const isMinDateAfterStartDate = isAfter(minDate, startDate)

        // if (isMinDateAfterStartDate || isMaxDateBeforeToday) {
        //   setMostrarAlerta(true)
        // } else {
        //   setMostrarAlerta(true)
        // }
      },
      keepPreviousData: true,
      refetchOnWindowFocus: false
    }
  )

  const getLegenda = () => {
    let startDate

    switch (selectedButton) {
      case '24h':
        return `${formatDate(today)}`
      case '48h':
        startDate = subDays(today, 2)
        return `De ${formatDate(startDate)} até ${formatDate(today)}`
      case '7d':
      case '15d':
      case '30d': {
        const days = parseInt(selectedButton)
        startDate = subDays(today, days)
        return `De ${formatDate(startDate)} até ${formatDate(today)}`
      }
      case 'periodo': {
        const days2 = parseInt(selectedButton)
        startDate = subDays(today, days2)
        return `De ${formatDate(datasDisponiveis.min)} até ${formatDate(datasDisponiveis.max)}`
      }
      default:
        return ''
    }
  }

  // const handleFecharAlerta = () => setMostrarAlesrta(false)

  return (
    <S.HistoricoWrapper>
      <Group>
        {buttons.map((button) => (
          <React.Fragment key={button.value}>
            <Botao
              disabled={loading}
              key={button.value}
              label={button.label}
              onClick={() => handleButtonFilter(button.value)}
              variant={button.value === selectedButton ? 'selected' : 'select'}
            />
            {visibleDate && button.value === 'periodo' && (
              <div
                className={`transition-container ${isPeriodo ? 'visible' : ''}`}
              >
                <DatePicker
                  minDate={minDatePeriodo}
                  maxDate={today}
                  prefixo="De:"
                  value={selectedDate.start}
                  onChange={(date) => handleSelectedDate('start', date)}
                />
                <DatePicker
                  maxDate={today}
                  prefixo="Até:"
                  minDate={selectedDate.start}
                  value={selectedDate.end}
                  onChange={(date) => handleSelectedDate('end', date)}
                />
              </div>
            )}
          </React.Fragment>
        ))}
      </Group>

      {loading && <LineSkeleton height={305} visible={loading} />}
      {!loading && (
        <>
          <Grafico
            data={data}
            visibleDate={visibleDate}
            selectedDate={selectedDate}
          />
          {data?.length > 0 && <S.Legenda>{getLegenda()}</S.Legenda>}
        </>
      )}
      {/* {mostrarAlerta && (
        <S.AlertWrapper>
          <AlertMantine
            radius="sm"
            title="Atenção!"
            type="warning"
            color="yellow"
            withCloseButton
            onClose={handleFecharAlerta}
            icon={<InfoIcon alt="info" />}
          >
            {`Nem todos os dias do período selecionado possuem dados disponíveis. Estamos exibindo as informações de ${formatDateToLabel(datasDisponiveis.min)} a ${formatDateToLabel(datasDisponiveis.max)}.`}
          </AlertMantine>
        </S.AlertWrapper>
      )} */}
    </S.HistoricoWrapper>
  )
}
